<div class="footer d-flex">
  <div class="row outer">
    <div>
      <img class="xmlid_1_" src="../../../assets/images/footer/k-img.png" />
    </div>
    <img
      class="logo mob"
      src="../../../assets/images/KlickitLogoWithoutSlogan.svg"
    />

    <div class="row inner">
      <!-- <img class="dark-logo mob" src="../../../assets/images/KlickitLogoWithoutSlogan.svg" /> -->

      <div class="mobileRow">
        <div class="footerInnerLogo">
          <img
            class="dark-logo web"
            src="../../../assets/images/KlickitLogoWithoutSlogan.svg"
          />
          <div class="find-us-online">
            <span class="avenir-medium-purple-14px" i18n>Find us online</span>
          </div>

          <div class="overlap-group-container">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/company/klickitegypt"
              class="overlap-group3"
            >
              <div class="svgexport-6-56-3"></div>
            </a>

            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/KlickitEgypt/"
              class="overlap-group3"
            >
              <div class="svgexport-6-56-2"></div>
            </a>

            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/klickitegypt"
              class="overlap-group3"
            >
              <div class="svgexport-6-56-1"></div>
            </a>
          </div>
        </div>
        <div class="footerInner">
          <div class="title">
            <span class="gillsans-medium-purple-14px" i18n>Company</span>
          </div>
          <div class="sublink">
            <a href="aboutus"  i18n>About Us</a>
          </div>
          <div class="sublink">
            <a
              class="gillsans-regular-normal-granite-gray-14px"
              href="comingsoon"

              i18n
              >Meet The Team</a
            >
          </div>
          <div class="sublink">
            <a
              class="gillsans-regular-normal-granite-gray-14px"
              href="contactus"
              i18n
              >Contact Us</a
            >
          </div>
        </div>
      </div>
      <div class="mobileRow">
        <div class="footerInner">
          <div class="title">
            <span class="gillsans-medium-purple-14px" i18n
              >Help &amp; Support</span
            >
          </div>
          <div class="sublink">
            <a href="privacy"  target="_blank" class="" i18n
              >Privacy Policy</a
            >
          </div>
          <div class="sublink">
            <a href="terms-and-conditions"  class="" i18n
              >Terms &amp; Conditions</a
            >
          </div>
          <div class="sublink">
            <a href="comingsoon"  class="" i18n>FAQ</a>
          </div>
        </div>
        <div class="footerInner">
          <div class="title">
            <span class="gillsans-medium-purple-14px" i18n>Get in Touch</span>
          </div>
          <div class="group-67">
            <div class="svgexport-6-53">
              <div class="group-4"></div>
            </div>
            <div class="sublink">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="mailto: info@klickit.co"
                i18n
                >info&#64;klickit.co</a
              >
            </div>
          </div>

          <div class="group-67 locationGroup">
            <div class="svgexport-6-53">
              <div class="group-5"></div>
            </div>
            <div class="sublink sublinkLocation">
              <a
                target="_blank"
                rel="noopener noreferrer"
                class="location"
                href="https://www.google.com/maps/place/Centro+Egypt+Mall/@30.0222127,31.5135219,17z/data=!3m1!4b1!4m5!3m4!1s0x1458221566f9fb45:0xdf89356b3869cbc6!8m2!3d30.0222081!4d31.5157106?hl=en"
                i18n
                >Office 221, Centro Egypt Mall, 5th Settlement, New Cairo 11835,
                Egypt</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="rectangle-62"></div> -->
</div>
